

































import "./objective-copy.less";
import Vue from "vue";

export default Vue.extend({
  name: "objective-copy",
  props: {
    objective: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      currentObjective: {
        id: "",
        name: "",
        timeline: [null, null],
        description: "",
        reviewId: null,
        toReviewId: null,
      },
      createACopy: false,
      rules: {
        toBioId: [
          {
            required: true,
            message: "Please select a Bio for moving or copying.",
            trigger: "blur",
          },
        ],
        toReviewId: [
          {
            required: true,
            message: "Please select a Review for moving or copying.",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "Please fill in the Objective Name",
            trigger: "blur",
          },
          {
            type: "string",
            max: 40,
            message: "Please limit your Objective Name to max 40 characters. Thanks!",
            trigger: "blur",
          },
        ],
        description: [
          {
            type: "string",
            max: 1200,
            message: "Please limit your Objective Description to max 1,200 characters. Thanks!",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    },
    toReviewOptions(): any {
      return this.$store.state.review.editableReviews || [];
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.currentObjective.name = this.objective.name;
        this.currentObjective.description = this.objective.description;
        this.currentObjective.reviewId = this.objective.reviewId;
        this.currentObjective.timeline = this.objective.timeline;

        this.$store.dispatch("review/getEditableReviews");

        this.currentObjective.toReviewId = this.objective.reviewId;
      }
    },
  },
  methods: {
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.ObjectiveForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      (this.$refs.ObjectiveForm as any).validate((valid: boolean) => {
        if (valid) {
          let copyObjectiveDto = {
            id: this.objective.id,
            name: this.currentObjective.name,
            description: this.currentObjective.description,
            fromReviewId: this.currentObjective.reviewId,
            toReviewId: this.currentObjective.toReviewId,
            isMove: !this.createACopy,
          };

          let context = this;
          let actionName = "review/copyObjective";
          context.$store
            .dispatch(actionName, { data: copyObjectiveDto })
            .then((response) => {
              context.$store.dispatch("review/get", {
                id: context.$store.state.review.currentReview.id,
              });
              context.$emit("cancel");
            })
            .finally(() => {
              target.disabled = false;
            });
        } else {
          target.disabled = false;
        }
      });
    },
  },
});
